import React from 'react';
import PropTypes from 'prop-types';

const IconPause = props => (
  <svg
    viewBox="0 0 11 14"
    role="presentation"
    aria-hidden="true"
    focusable="false"
    width="20px"
    height="20px"
    fill={props.fill || '#FFFFFF'}
    {...props}
  >
    <path
      d="m0 1.01c0-.56.44-1.01 1.01-1.01h1.98c.56 0 1.01.45 1.01 1.01v11.98c0 .56-.44 1.01-1.01 1.01h-1.98c-.56 0-1.01-.45-1.01-1.01zm7 0c0-.56.44-1.01 1.01-1.01h1.98c.56 0 1.01.45 1.01 1.01v11.98c0 .56-.44 1.01-1.01 1.01h-1.98c-.56 0-1.01-.45-1.01-1.01z"
      fillRule="evenodd"
     />
  </svg>
);

IconPause.propTypes = {
  fill: PropTypes.string,
};

export default IconPause;
